import BaseTransformer from "./base.transformer"
import qrDesignTypologyTransformer from "./qrTypology.transformer"
import qrLandingTransformer from "./qrLandings.transformer"
export const baseUri = "/api/qr-designs"

class qrDesignDesignsTransformer extends BaseTransformer {
  static fetch(qrDesign) {
    const uuid = this.transformUuid(qrDesign)
    return this.removeEmptyProps({
      uuid,
      iri: this.uuidToIri(baseUri, uuid),
      contentStatus: qrDesign.contentStatus,
      input: qrDesign.input,
      typology: qrDesignTypologyTransformer.fetch(
        typeof qrDesign.typology === "string"
          ? { uuid: qrDesign.typology.split("/").pop() }
          : qrDesign.typology
      ),
      landing: qrLandingTransformer.fetch(
        typeof qrDesign.landing === "string"
          ? { uuid: qrDesign.landing.split("/").pop() }
          : qrDesign.landing
      )
    })
  }
}

export default qrDesignDesignsTransformer
